"use client";

import { cn } from "@/lib/utils";
import SubPageHeaderImage from "./SubPageHeaderImage";
import CardTitleText from "./ui/CardTitleText";
import { StaticImageData } from "next/image";

export default function SubPageHeader({
  imgSrc,
  bottomGradient,
  cardTitle,
  cardText,
  cardWidth,
}: {
  imgSrc: string | StaticImageData;
  bottomGradient?: boolean;
  cardTitle: string;
  cardText: string;
  cardWidth?: string;
}) {
  return (
    <section className="-mb-20 flex flex-col px-6 lg:-mb-50">
      <header>
        <SubPageHeaderImage imgSrc={imgSrc} bottomGradient={bottomGradient} />
        <div className="mx-auto max-w-300 self-end">
          <div
            className={cn(
              "shadow-primary-dark/15 relative bottom-20 z-30 mt-4 flex flex-col items-center justify-between gap-4 rounded-2xl border border-gray-100 bg-white/95 p-4 shadow-lg backdrop-blur-lg md:rounded-br-[90px] lg:bottom-35 lg:p-8",
              cardWidth,
            )}
          >
            <CardTitleText cardTitle={cardTitle} cardText={cardText} />
          </div>
        </div>
      </header>
    </section>
  );
}
